import React from "react";
import { useMediaQuery } from "react-responsive";

import { DangerouslyHtml } from "@components/item";
import {
  DrupalTableCommonStyle,
  GettingHereTableContainer,
} from "@pages/about-us/AboutUsStyling";

const GettingHereTable = ({ table }) => {
  const isDesktop = useMediaQuery({ minWidth: 1200 });

  return (
    <GettingHereTableContainer>
      <DrupalTableCommonStyle>
        {table?.map((data) => {
          return (
            <DangerouslyHtml
              value={data}
              custom={{
                width:
                  isDesktop && data?.includes("half-table")
                    ? "calc(50% - 2rem)"
                    : "100%",
              }}
            />
          );
        })}
      </DrupalTableCommonStyle>
    </GettingHereTableContainer>
  );
};

export default GettingHereTable;
